<template>
    <header class="navbar">
        <div class="container navbar-content">
            <router-link to="/admin/dashboard" class="logo">KC-Afrobraids</router-link>

            <nav class="nav-links">
                <router-link :to="{name: 'adminServices'}">SERVICES</router-link>
                <router-link :to="{name: 'adminGallery'}">GALLERY</router-link>
                <router-link :to="{name: 'registerStylist'}">REGISTER STYLIST</router-link>
                <router-link :to="{name: 'adminProfile'}">PROFILE</router-link>
                <a @click="handleLogout" style="cursor: pointer" class="logout-link">LOGOUT</a> 
            </nav>

            <button class="menu-toggle" @click="toggleMenu" aria-label="Toggle Menu">
                {{ isMobileMenuOpen ? '✕' : '☰' }}
            </button>
        </div>
        
        <nav class="mobile-menu" v-show="isMobileMenuOpen">
            <router-link :to="{name: 'adminServices'}" @click="toggleMenu">SERVICES</router-link>
            <router-link :to="{name: 'adminGallery'}" @click="toggleMenu">GALLERY</router-link>
            <router-link :to="{name: 'registerStylist'}">REGISTER STYLIST</router-link>
            <router-link :to="{name: 'adminProfile'}">PROFILE</router-link>

            <a @click="handleLogout" style="cursor: pointer" class="logout-link">LOGOUT</a> 
        </nav>
    </header>
</template>

<script>
import { logoutUser } from '@/services/AxiosClient'; 

export default {
    name: 'AdminNavbar',
    data() {
    return {
        isMobileMenuOpen: false, 
        
    }
    },
    methods: {
        handleLogout() {
            if (confirm("Are you sure you want to log out?")) {
                logoutUser(); 
                this.isMobileMenuOpen = false;
            }
        },
        toggleMenu() {
            this.isMobileMenuOpen = !this.isMobileMenuOpen;
        }
    }
}
</script>

<style scoped>

    a {
        text-decoration: none;
        color: inherit;
    }

    .container {
        max-width: 1200px;
        margin: 0 auto;
        padding: 0 1rem;
    }

    /* 1. Navbar Styling */
    .navbar {
        background-color: var(--light-color); /* Light background for Admin bar */
        box-shadow: var(--shadow);
        position: sticky;
        top: 0;
        z-index: 1000;
    }

    .navbar-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 1rem 0;
    }

    /* 2. Logo */
    .logo {
        font-size: 1.8rem;
        font-weight: bold;
        color: var(--color-maroon); /* Maroon logo for Admin */
        font-family: 'Georgia', serif; 
    }

    /* 3. Desktop Nav Links */
    .nav-links {
        display: none; 
        align-items: center;
        gap: 1.5rem;
    }

    .nav-links a {
        padding: 0.5rem 1rem;
        color: var(--dark-color); /* Dark text on light background */
        transition: color 0.3s;
    }

    .nav-links a:hover,
    .nav-links a.router-link-exact-active {
        color: var(--color-gold); /* Gold hover effect */
    }

    /* Menu Toggle */
    .menu-toggle {
        display: block; /* Visible on mobile */
        font-size: 1.5rem;
        cursor: pointer;
        border: none;
        background: none;
        color: var(--dark-color); /* Dark hamburger icon */
    }
    
    .mobile-menu {
        display: flex; /* Allows v-show to toggle */
        flex-direction: column;
        
        background-color: var(--light-color); /* Light background */
        position: absolute; 
        width: 100%;
        left: 0;
        border-top: 1px solid var(--secondary-color);
        text-align: center;
        box-shadow: 0 8px 10px rgba(0, 0, 0, 0.1);
    }
    .mobile-menu a {
        display: block;
        padding: 0.75rem 1rem;
        color: var(--dark-color);
        border-bottom: 1px solid var(--secondary-color);
    }
    .mobile-menu a:hover {
        background-color: var(--secondary-color);
        color: var(--color-maroon); /* Maroon hover color */
    }

    /* 6. Logout Link Styling */
    .logout-link {
        font-weight: bold;
        color: var(--color-maroon) !important; /* Maroon for high visibility */
        text-transform: uppercase;
    }
    .logout-link:hover {
        color: var(--color-gold) !important;
    }
    
    /* 7. Desktop View (>= 768px) */
    @media (min-width: 768px) {
        .nav-links {
            display: flex; /* Show desktop links */
            align-items: center;
            gap: 1.5rem;
        }
        
        .menu-toggle {
            display: none; /* Hide toggle button */
        }
        
        .mobile-menu {
            display: none !important; /* Ensure mobile menu is hidden */
        }
    }
</style>